/**
 * Custom cart functions
 */

/*global __wtcc*/

window.onload = ( $ => {

    /**
     * SAFE JSON PARSE FUNCTION
     *
     * Created by Stim, 24.01.2018
     * Purpose: we experienced some extra output to our JSON response from Pacsoft/Unifaun integration for WooCommerce plugin
     * Goal: filter out all non-json output (clean json) and parse it safely
     *
     * @param s
     *
     * @return Object
     */
    const __safe_parse = function( s ) {
        let start = s.indexOf( '{' );
        let end = s.lastIndexOf( '}' ) - start + 1;
        let to_parse = s.substr( start, end );
        let parsed = null;
        try {
            parsed = JSON.parse( to_parse )
        } catch ( e ) {
            console.error( e );
        }
        return parsed;
    };

    /**
     * Update interval handler
     *
     * @type {number}
     * @private
     */
    let __update = 0;

    /**
     * Prevent any default actions
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    const __no_return = function( e ) {
        e.stopPropagation();
        e.preventDefault();
        return false;
    };

    /**
     * Proper form serialization
     *
     * @param $form
     * @param $init
     * @private
     */
    const __formData = function( $form, $init ) {
        let unindexed_array = $form.serializeArray();
        let indexed_array = $init || {};
        $.map( unindexed_array, function( n ) {
            indexed_array[ n[ 'name' ] ] = n[ 'value' ];
        } );
        return indexed_array;
    };

    /**
     * Call our own AJAX handler to refresh the cart
     *
     * @private
     */
    const __refresh_cart = function() {
        $( '.buddy-cart' ).block( { message: "", overlayCSS: { background: '#fff', opacity: '.3' } } );
        $.ajax( {
            url: __wtcc.ajaxurl,
            data: __formData( $( '.buddy-cart form' ), { action: __wtcc.ajaction } ),
            type: 'post',
            dataType: 'text',
            timeout: 0,
            success: data => {
                if ( !data ) return;
                let response;
                if ( !( response = __safe_parse( data ) ) ) return;
                if ( response.error )
                    return console.error( response.error );
                $( '.buddy-cart-refreshable' ).replaceWith( response.cart );
                $( '.cart-contents__count' ).html( response.count );
                if ( response.discount && !response.discount.discount_applied )
                    $( ".coupon-controls" ).before( '<span class="buddy-cart__msg-new">' + response.discount.discount_message + '</span>' );
                __assign();
            },
            complete: () => {
                $( '.buddy-cart' ).unblock();
            },
            error: ( a, b, error ) => {
                if ( error ) console.log( error );
            }
        } );
    };

    /**
     * Refresh cart with new quantities (delayed)
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    const __qty_changed = function( e ) {
        if ( '' === $( this ).val() ) return;
        if ( __update )
            clearTimeout( __update );
        __update = setTimeout( __refresh_cart, 500 );
        return __no_return( e );
    };

    /**
     * Alternate quantity value
     *
     * @param e
     * @returns {boolean|*}
     * @private
     */
    const __qty = function( e ) {
        let a = 1;
        if ( $( this ).hasClass( 'minus' ) )
            a = -1;
        let qf = $( this ).parent().find( 'input' ).first();
        let min = qf.attr( 'min' ) || 0;
        let max = qf.attr( 'max' ) || 1000;
        let nv = Number( qf.val() ) + a;
        if ( nv >= min && nv <= max ) {
            qf.val( nv ).trigger( 'change' );
            if ( $( this ).parents( '.buddy-cart__list-item--added' ).length > 0 )
                return __qty_changed( e );
        }
        return __no_return( e );
    };

    /**
     * Update price when upsell quantity has changed
     *
     * Cart - Upsell price is not changed https://www.wrike.com/open.htm?id=684800052
     *
     * @param e
     * @returns {boolean|*}
     * @private
     */
    const __qty_upsell_changed = function( e ) {
        let
            parent      = $( this ).parents( 'li' ).first(),
            product_id  = parent.find( 'button.single_add_to_cart_button' ).data( 'product_id' ),
            price       = __wtcc.upsells_variations_prices[ product_id ],
            new_price;

        new_price = price * $( this ).val();

        parent
            .find( '.upsells-item__price .amount bdi' )
            .first()
            .contents()
            .first()
            .replaceWith(
                new_price.toFixed(2).replace( '.', ',' ) + ' '
            );

        return __no_return( e );
    };

    /**
     * Change variation of cart item
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    const __change_item_variation = function( e ) {

        const _input_element = $( '#change_item_variation' ),
        _this = $( e.target );

        const _value = {
            "cart_item_key": _this.data( 'cart_item_key'),
            "product_id": _this.data( 'product_id' ),
            "variation_id": _this.val(),
            "qty": _this
                .parents('.buddy-cart__list-item-block')
                .siblings( '.buddy-cart__list-item-block--product-quantity' )
                .find( $('.qty-controls__input') )
                .val()
        }

        if ( _input_element.length ) {
            _input_element.val( JSON.stringify( _value ));
            __refresh_cart();
        }

        return __no_return( e );
    };

  /**
   * Change interval event
   *
   * @changed logic for letting one-time item be mixed with other same-period subscription items.
   *          See https://www.wrike.com/open.htm?id=810928938
   *
   * @param e
   * @returns {boolean}
   * @private
   */
  const __change_interval = function( e ) {
    let
      _v = $( this ).val(),
      _p = $( this ).parents( 'li.buddy-cart__list-item' ).first(),
      _s = _p.find( '.wcsatt-options input[value=' + _v + ']' );
    if( ! _s.length ) return __no_return( e );
    _s.trigger( 'click' );
    if( _v !== '0' ){
      let _n = _s.attr( 'name' );
      $( '.buddy-cart .wcsatt-options input[value=' + _v + ']' ).each( function(){
        let _cv = $( ".buddy-cart form input[name='" + $( this ).attr( 'name' ) + "']:checked" ).val();
        if( this.name !== _n && _cv !== '0' ) $( this ).trigger( 'click' );
      } );
    }
    __refresh_cart();
    return __no_return( e );
  };

    /**
     * Apply coupon event
     *660635417

     * @param e
     * @returns {boolean}
     * @private
     */
    const __apply_coupon = function( e ) {
        if ( $( '#coupon_code' ).val() )
            __refresh_cart();
        return __no_return( e );
    };

    /**
     * Remove an item from the cart
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    const __remove_item = function( e ) {
        let x = $( this ).parents( 'li' ).first();
        x.fadeOut( 200, function() {
            x.remove();
            __refresh_cart()
        } );
        return __no_return( e );
    };

    /**
     * Remove a coupon from the cart
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    const __remove_coupon = function( e ) {
        $( '#remove_coupon' ).val( $( this ).data( 'coupon' ) );
        $( this ).parents( 'div.cart-discount' ).first().fadeOut( 300, __refresh_cart );
        return __no_return( e );
    };

    /**
     * Add upsell product to the cart
     *
     * @param e
     * @returns {boolean}
     * @private
     */
    const __upsells_add_to_cart = function( e ) {
        const _id = $( this ).data( 'product_id' ),
            _qty = $( this ).parents( 'li' ).first().find( '.qty-controls__input' ).val();

        $( '#add_to_cart' ).val( _id );
        $( '#add_to_cart_qty' ).val( _qty );
        __refresh_cart();
        return __no_return( e );
    };

    /**
     * Select variation price and id
     *
     * @private
     */
    const __selected_variation = function() {
            const parent = $( this ).parents( 'li' ).first();
            parent.find( '.single_add_to_cart_button' ).first()
                .attr( 'data-product_id', $( this ).val() )
                .data( 'product_id', $( this ).val() );
            parent.find( 'input.qty' ).trigger( 'change' );
        },


        /**
         * Initialize custom select controls
         *
         * @private
         */
        __init_custom_selects = function() {
            const checkoutSelects = document.querySelectorAll( '.choices-select' );
            checkoutSelects.forEach( item => {
                const checkoutCustomSelect = new Choices( item, {
                    searchEnabled: false,
                    itemSelectText: '',
                    shouldSort: false,
                    placeholder: false,
                    position: 'bellow',
                    classNames: {
                        containerInner: 'choices__inner choices-select',
                    },
                } );
                const valueArray = checkoutCustomSelect.getValue();

                if ( valueArray.label === 'One time purchase' || valueArray.label === 'One time' ) {
                    $( ".buddy-cart__msg" ).removeClass( 'hidden' )
                } else {
                    $( ".buddy-cart__msg" ).addClass( 'hidden' )
                }
            } )


            const checkoutRecSelects = document.querySelectorAll( '.woocommerce-cart select.item-variations' );
            checkoutRecSelects.forEach( item => {

                const checkoutUpsellSelect = new Choices( item, {
                    searchEnabled: false,
                    itemSelectText: '',
                    shouldSort: false,
                    placeholder: false,
                    position: 'bellow',
                    classNames: {
                        containerInner: 'choices__inner choices-select',
                    },
                } );

                item.addEventListener('choice', function () {
                    console.log('choosen');
                })
            } )
        },


        /**
         * Initialize slider in product details popup
         *
         * @private
         */
        __init_slick_slider = function() {
            $( '.cart-product-details .woocommerce-product-gallery__wrapper' ).each( function( index, element ) {
                if ( $( element ).hasClass( 'slick-initialized' ) ) {
                    $( element ).slick( 'unslick' );
                }
                $( element ).slick( {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true
                } );
            } )
        },


        /**
         * Close accordion
         * @private
         */
        __close_accordion = function() {
            $( '.accordion-area__content' ).hide();
        },


        /**
         * Open or close coupon form
         * @param e
         * @private
         */
        __toggle_coupon_form = function( e ) {
            e.preventDefault();

            let currentTarget = $( e.currentTarget ),
                duration = 150;

            currentTarget.toggleClass( 'active' );

            if ( currentTarget.hasClass( 'active' ) ) {
                currentTarget.siblings( '.coupon-controls' ).slideDown( duration );
            } else {
                currentTarget.siblings( '.coupon-controls' ).slideUp( duration );
            }

        },


        /**
         * Open or close accordion
         *
         * @param e
         * @private
         */
        __toggle_accordion = function( e ) {
            e.preventDefault();

            if ( $( e.currentTarget ).hasClass( 'active' ) ) {
                $( '.accordion-area__title' ).removeClass( 'active' );
                $( '.accordion-area__content' ).slideUp( 300 );
            } else {
                $( e.currentTarget ).parent().siblings().children( '.accordion-area__title' ).removeClass( 'active' );
                $( e.currentTarget ).parent().siblings().children( '.accordion-area__content' ).slideUp( 300 );
                $( e.currentTarget ).addClass( 'active' ).siblings( '.accordion-area__content' ).slideDown( 300 );
            }
        },


        /**
         * Disable scroll
         * @private
         */
        __disable_page_scroll = function() {
            $( 'html, body' ).addClass( 'no-scroll' );
        },

        /**
         * Enable scroll
         * @private
         */
        __enable_page_scroll = function() {
            $( 'html, body' ).removeClass( 'no-scroll' );
        },

        /**
         * Close popup with cart item details
         * @param e
         * @private
         */
        __close_details_popup = function( e ) {
            e.preventDefault();
            __enable_page_scroll();
            $( e.currentTarget ).parents( '.cart-product-details' ).addClass( 'hidden' );
        },


        /**
         * Open popup with cart item details
         * @param e
         * @private
         */
        __open_details_popup = function( e ) {
            __no_return( e );
            __disable_page_scroll();
            $( e.currentTarget ).parents( '.buddy-cart__list-item-block' ).siblings( '.cart-product-details' ).removeClass( 'hidden' );
        },


        /**
         * Make cart totals block sticky on mobiles
         * @private
         */
        __sticky_totals = function() {
            const right_col = document.querySelector( '.buddy-cart__right-column' );
            const collaterals = $( '.buddy-cart__collaterals' );

            if ( $( window ).width() > 991 ) {
                right_col.classList.remove( 'sticky' );
                collaterals.removeAttr('style');
                return null
            }

            const left_col = document.querySelector( '.buddy-cart__left-column' );
            const left_col_rect = left_col.getBoundingClientRect();
            const left_col_bottom_page_offset = left_col_rect.height + left_col_rect.top + pageYOffset;

            if ( window.innerHeight + window.pageYOffset < left_col_bottom_page_offset ) {
                right_col.classList.add( 'sticky' );
                if ( !$( '.buddy-cart__collaterals-item--mobile' ).hasClass( 'opened' ) ) {
                    collaterals.hide();
                }
            } else {
                right_col.classList.remove( 'sticky' );
                collaterals.show();
            }
        },



        /**
         * Toggle open/close sticky cart totals on mobiles
         * @private
         */
        __toggle_cart_totals = function( e ) {
            __no_return( e );
            if ( !$( this ).parents('.sticky').length ) {
                return null;
            }

            if ( $( this ).hasClass( 'opened' ) ) {
                $( this ).removeClass( 'opened' );
                $( '.buddy-cart__collaterals.cart_totals' ).slideUp( 200 );
            } else {
                $( this ).addClass( 'opened' );
                $( '.buddy-cart__collaterals.cart_totals' ).slideDown( 200 );
            }
        };

    /**
     * Assign all custom cart events
     *
     * @private
     */
    const __assign = function() {
        $( window ).on( 'scroll', __sticky_totals );
        $( '.buddy-cart__collaterals-item--mobile' ).off().on( 'click', __toggle_cart_totals );
        $( window ).on( 'resize', __sticky_totals );
        $( '.buddy-cart .remove' ).off().on( 'click', __remove_item );
        $( '.buddy-cart .woocommerce-remove-coupon' ).off().on( 'click', __remove_coupon );
        $( '.buddy-cart .qty-controls button' ).off().on( 'click', __qty );
        $( '.buddy-cart__list-item--added .quantity input' ).off().on( 'change', __qty_changed );
        $( '.buddy-cart__list-item.upsells-item .quantity input').off().on( 'change', __qty_upsell_changed );
        $( '.product-variations' ).off().on( 'change', __change_item_variation );
        $( '.intervals .choices-select' ).off().on( 'change', __change_interval );
        $( '.buddy-cart .buddy-cart__coupon-form button' ).off().on( 'click', __apply_coupon );
        $( '.single_add_to_cart_button' ).off().on( 'click', __upsells_add_to_cart );
        $( '.upsells-item-control.item-variations' ).off().on( 'change', __selected_variation );
        $( '.close-details' ).off().on( 'click', __close_details_popup );
        $( '.cart_item .buddy-cart__list-item-block--product-thumbnail a' ).off().on( 'click', __open_details_popup );
        $( '.accordion-area__title' ).off().on( 'click', __toggle_accordion );
        $( '.coupon__title' ).off().on( 'click', __toggle_coupon_form );
        $( '.coupon__input' ).off().on( 'change keyup blur paste', function() {
            $( '#coupon_code' ).val( $( this ).val() )
        } );
        __init_custom_selects();
        __init_slick_slider();
        __close_accordion();
        __sticky_totals();
    };

    /**
     * Initialize
     *
     * @private
     */
    const __init = function() {
        __assign();
        $( document.body ).on( 'updated_wc_div', __assign );
        console.log( 'Custom cart JS initiated!' );
    };

    return {
        /**
         * Call to init ourselves only when we are on our custom cart page
         */
        init: function() {
            if ( !$( '.buddy-cart' ).length ) return false;
            __init();
            return true;
        }
    }

} )( jQuery.noConflict() ).init();
